module.exports = __webpack_public_path__ + "img/timer.5f0ba2c.svg";